<template>
  <el-button-group class="option-card-btn__group">
    <gj-tooltip v-if="help">
      <template #content>
        全店铺看板中所有涉及Review相关数据均以国家维度统计
      </template>
      <gj-button type="icon" plain>
        <i class="iconfont iconxiaoxitishi"></i>
      </gj-button>
    </gj-tooltip>
    <gj-button class="option-card-btn__btn" size="medium" type="icon" icon="el-icon-refresh-right"
               v-if="showList.includes('refresh')" @click="refresh"></gj-button>
    <gj-button class="option-card-btn__btn" size="medium" type="icon" icon="el-icon-download"
               v-if="showList.includes('download')" @click="download"></gj-button>
    <gj-button class="option-card-btn__btn" size="medium" type="icon" icon="el-icon-setting"
               v-if="showList.includes('setting')" @click="openCustomColumnModal"></gj-button>
  </el-button-group>
</template>

<script>
import _ from "lodash";

export default {
  name: "opttion-group",
  props:{
    help:null,
    //模块唯一标识
    moduleId:{
      type: String,
      require: true
    },
    showList: {
      type: Array,
      default: () => ["refresh",'download','setting']
    },
    //是否显示看板按钮
    showPanelBtn: {
      type: Boolean,
      default: false,
    },
    //是否显示看板变量
    isShowPanel:{
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {

    }
  },
  methods:{
    /**
     * 刷新
     */
    refresh(){
      this.$emit("refresh")
    },
    /**
     * 下载
     */
    download(){
      this.$emit("download")
    },
    /**
     * 设置
     */
    openCustomColumnModal(){
      this.$emit("openCustomColumnModal")
    },
    /**
     * 显示/关闭看板说明
     */
    showPanel(){
      this.$emit("showPanel", !this.isShowPanel)
      this.isShowPanel = !this.isShowPanel;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../modules/statistics/shop-wide-analysis/common/index.scss";

/deep/ .gj-tooltip{
  float: left;
  position: relative;
}
/deep/ .option-card-btn__btn {
  margin-left: 10px !important;
}
.option-card-btn__group{
  /deep/ .el-button.option-card-btn__btn{
    border-radius: 2px;
  }
}
</style>
